import {Link} from 'react-router-dom'
import styled from 'styled-components'
import ArrowRightSVG from '../../images/arrow_right.svg'
import {wrappers} from '../../pages/Homepage/data'

export const PageWrapper = styled.div`
padding-top: 8vh;
background-color: #222;

@media screen and (max-width: 768px) {
    padding: 2vh;
}
`

export const SectionSeperator = styled.div`
background: #222;
height: 4vh;
margin: 7vh 0;
`

export const SectionWrapper = styled.div`
border-radius: 45px;
${({larger}) => larger===true ? 'width:90vw; padding: 5vh 0 10vh;' : 'width: 80vw; padding: 5vh 5vw 10vh;'}

height: 100%;
margin: 5px auto;
margin-bottom: 100px;
background-position-x: ${({img_first, wrapper_left}) => wrapper_left ? 'left' : img_first ? 'right' : 'left'};
text-align: ${({img_first}) => img_first ? 'left' : 'right'};

background-image: linear-gradient(to bottom left, #292929, #262626);
background-size: contain;


@media screen and (max-width: 560px){
    background-size: cover;

}
  

&:hover{
    background-image: url('${({imgID}) => wrappers[imgID]}'); /* The image used */
    background-color: #363636;
    background-repeat: no-repeat; /* Do not repeat the image */
}

`

export const KitDescWrapper = styled.div`
height: 100%;
max-height: 630px;
padding: 0 2vw;
display: flex;
justify-content: center;
flex-direction: column;

@media screen and (max-width: 768px) {
    text-align: center;
    padding: 3vw;
}
`

export const KitTitle = styled.h2`
display: inline-block;
width: fit-content;
color: ${({color}) => (color==='') ? '#fff' : color};
background-color: ${({bg_color}) => (bg_color==='') ? 'inherit' : bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
margin: 0;
line-height: 1.3;
font-weight: bold;

@media screen and (max-width: 768px) {
    font-size: 24px;
}
`

export const KitDescText = styled.p`
color: ${({color}) => (color==='') ? '#fff' : color};
background-color: ${({bg_color}) => (bg_color==='') ? 'inherit' : bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
margin: 6vh 0;

@media screen and (max-width: 768px) {
    font-size: 16px;
    margin: 2vh auto;
}

@media screen and (max-width: 480px) {
    font-size: 14px;
    margin: 2vh auto;
}
`

export const KitButton = styled(Link)`
display: flex;
align-items: center;
justify-content: center;
width: 15vw;
height: 8vh;
margin-top: 4vh;
border: 2px solid ${({color}) => color};
color: #fff;
background-color: inherit;
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: ${({font_size}) => (font_size==='') ? 'inherit' : font_size};
text-align: center;
text-decoration: none;
cursor: pointer;
opacity: 0.9;
align-self: ${({img_first}) => img_first ? 'inherit' : 'flex-end'};

@media screen and (max-width: 768px) {
    margin: 0 auto;
    width: 30vw;
    height: 4vh;
    font-size: 15px;
    line-height: 3vh;
    padding: 0.27vh 0;
}

@media screen and (max-width: 480px) {
    font-size: 10px;
}

&:hover, &:active {
    text-decoration: none;
    color: white;
}

&:hover{
    text-decoration: none;

    background-color: ${({color}) => color};
    opacity: 1;
}

&:active{
    background-color: ${({color}) => color};
    opacity: 1.2;
}

`

export const KitImageWrapper = styled.div`
width: 25vw;
margin: 0 auto;
`

export const Image = styled.img`
display: block;
width: 100%;
max-width: 400px;
margin: 0 auto;
`

export const ArrowRight = styled.div`
display: inline-block;
margin-left: 1.3vw;
background-color: inherit;
background-image: url('${ArrowRightSVG}'); /* The image used */
background-size: contain;
background-repeat: no-repeat; /* Do not repeat the image */
width: 16px;
height: 16px;
border-radius: 9px;

@media screen and (max-width: 768px) {
    margin-left: 1.6vw;
    width: 10px;
    height: 10px;
}

@media screen and (max-width: 480px) {
    width: 7px;
    height: 7px;
}

transition: all 0s linear;

`
